/**
 * Dynamic mapping platform <-> slug for dynamic routing and SEO.
 * Always generated from config/platforms.json for Clean Architecture, DRY, and maintainability.
 * 
 * Do NOT hardcode mapping here. All platform/slug data comes from config/platforms.json.
 */

import platformsConfig from '../../../config/platforms.json';

// Generate mapping: platform id -> slug
export const platformSlugs: Record<string, string> = {};
// Generate mapping: slug -> platform id
export const slugToPlatform: Record<string, string> = {};

if (Array.isArray(platformsConfig.platforms)) {
  for (const p of platformsConfig.platforms) {
    if (p.id && p.slug) {
      platformSlugs[p.id] = p.slug;
      slugToPlatform[p.slug] = p.id;
    }
  }
}
